import LinkCertificationTrainingManagementForm from "../../modules/link-certification-training-management/form/LinkCertificationTrainingManagementForm.vue"
import LinkCertificationTrainingManagement from "../../modules/link-certification-training-management/view/LinkCertificationTrainingManagement.vue"

import RouterViewRender from "../../utils/routes/router-view-render";

const LinkCertificationTrainingManagementRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
   {
      path: "vincular-certificacao-treinamento",
      component: LinkCertificationTrainingManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "formulario-vincular-certificacao-treinamento/:id",
      component: LinkCertificationTrainingManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
    
  ],
};

export default LinkCertificationTrainingManagementRoutes;
